// gimme: conversations-thread-view 06/30/2021 cfef6b9a8b3badc65b082ffd722b737fa8d16bdf
'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectExistingFileButton = ({
  onClick
}) => /*#__PURE__*/_jsx(Button, {
  "data-test-id": "choose-existing-file-button",
  onClick: onClick,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "composer-ui.prosemirror.plugins.attachments.select-existing-file-label"
  })
});
SelectExistingFileButton.displayName = 'SelectExistingFileButton';
SelectExistingFileButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default SelectExistingFileButton;